export default "__VITE_ASSET__CbZwdV3m__"